import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { appPaths } from "../shared/routing/appPaths";
import StatusMessage from "../ui/feedback/StatusMessage";

/**
 * A page's one empty state while no project is chosen (TR-A2-02): what to do and where. The
 * page shows it once; its sidebar shows nothing beside it.
 */
export default function ProjectNeeded() {
  const { t } = useTranslation();
  return (
    <StatusMessage tone="info" title={t("projects.needed.title")}>
      <Link to={appPaths.projects()} className="app-link underline">{t("projects.needed.action")}</Link>
    </StatusMessage>
  );
}
